export interface ClubOption {
  id: number;
  name: string;
  club_type_name: string | null;
  // An @ant-design/icons name (ClubTypeIcon); null = none chosen.
  club_type_icon: string | null;
  // Its weekdays as numbers, 1 = Monday … 7 = Sunday.
  week_day_numbers: number[];
  teacher_name: string | null;
  timesheet: string | null;
  week_days: string[];
  start_date: string | null;
  available_spot: number | null;
  total_price: number;
  monthly_price: number;
  months_count: number;
  member_count: number;
  // Students with at least one Outstanding payment (unpaid invoice).
  unpaid_student_count: number;
  // Хоосон бол бүх ангид нээлттэй.
  class_year_ids: number[];
}

export interface ParentDetails {
  full_name: string | null;
  relation: string | null; // student_parent.parent_type: Эцэг, Эх, ...
  phone: string | null;
  email: string | null;
  home_address: string | null;
  facebook: string | null;
}

// Shared by both lists: who the student is.
interface StudentInfo {
  student_name: string;
  class_name: string | null;
  parent_name: string | null;
  parent: ParentDetails | null;
  has_voucher: boolean;
}

// A Membership (every one a full member, CONTEXT.md).
export interface MemberRow extends StudentInfo {
  id: number; // club_student id
  joined_date: string | null;
  outstanding_amount: number;
}

// One Club month's bill: its period and how many of its Sessions it covers
// (CONTEXT.md: Club invoice). Null on one from before recurring billing.
export interface ClubPeriod {
  period_start: string | null;
  period_end: string | null;
  sessions_billed: number | null;
  sessions_total: number | null;
}

// An Outstanding payment: one unpaid Club invoice.
export interface OutstandingRow extends StudentInfo, ClubPeriod {
  id: number; // invoice id
  card_balance: number;
  amount: number;
  months_count: number | null;
  created_date: string | null;
}

// One of a Membership's invoices, in the Cancel drawer.
export interface MembershipInvoice extends ClubPeriod {
  id: number;
  total_price: number;
  status: 'PENDING' | 'PAID' | 'CANCELLED' | 'REFUNDED';
  months_count: number | null;
  created_date: string | null;
  // A Cancel today: what an Outstanding one stays owing (0 = voided), and
  // what a paid one would give back (CONTEXT.md: Cancel).
  cancel_keep_amount: number;
  refundable_amount: number;
}

export interface ClassOption {
  id: number;
  name: string;
  class_number: number | null;
  class_year_id: number | null;
}

export interface StudentOption {
  id: number;
  full_name: string;
  code: string;
  card_balance: number;
}

// "2026-10-15 — 2026-11-14 · 3/6 өдөр": a Club invoice's period. `withSessions: false`
// leaves off the "3/6 өдөр" part.
export function formatPeriod(
  row: ClubPeriod & { created_date?: string | null },
  { withSessions = true }: { withSessions?: boolean } = {},
): string {
  const day = (d: string) => d.slice(0, 10);
  if (!row.period_start || !row.period_end) {
    return row.created_date ? day(row.created_date) : '—';
  }
  const sessions =
    withSessions && row.sessions_total != null
      ? ` · ${row.sessions_billed}/${row.sessions_total} өдөр`
      : '';
  return `${day(row.period_start)} — ${day(row.period_end)}${sessions}`;
}

export function formatMNT(n: number): string {
  return `${new Intl.NumberFormat('mn-MN').format(n)}₮`;
}

// A failed runQuery rejects with the server's `{ error }` body.
export function queryErrorMessage(e: unknown): string {
  return (e as { error?: string } | undefined)?.error ?? 'Алдаа гарлаа.';
}
